import { Button, Image, Modal, Radio, message } from "antd";
// import FileUpload from "components/Input/FileUpload";
import React, { useState } from "react";
import SignaturePad from "react-signature-canvas";
let sigPad = {};
const Signature = () => {
  const [isDraw, setIsDraw] = useState(true);
  const [signatureData, setSignatureData] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setSignatureData(sigPad.getTrimmedCanvas().toDataURL("image/png"));
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const onClear = () => {
    if (isDraw) {
      setSignatureData(null);
      sigPad.clear();
    } else {
      message.success("Empty");
    }
  };

  const onChange = (e) => {
    console.log(`radio checked:${e.target.value}`);
    if (e.target.value === "a") {
      setIsDraw(true);
    } else {
      setIsDraw(false);
    }
  };
  return (
    <>
      <Modal
        onCancel={handleCancel}
        title={signatureData ? "Signature Preview" : "Add Signature"}
        open={isModalOpen}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,

          <Button onClick={onClear}>Clear</Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            Save
          </Button>,
        ]}
      >
        <Radio.Group
          onChange={onChange}
          defaultValue="a"
          style={{ display: "flex", justifyContent: "end" }}
        >
          <Radio.Button value="a">Signature</Radio.Button>
          <Radio.Button value="b">Upload</Radio.Button>
        </Radio.Group>
        {isDraw ? (
          <SignaturePad
            ref={(ref) => {
              sigPad = ref;
            }}
            canvasProps={{ className: "signature_pad" }}
          />
        ) : <></>}
      </Modal>
      <Button
        onClick={showModal}
        style={{
          marginBottom: 0,
          width: "100%",
          border: "1px solid #282f47",
        }}
      >
        {signatureData ? "Signature Preview" : "Add Signature"}
      </Button>

      {signatureData ? (
        <div className="signature_preview">
          <Image preview={false} src={signatureData} height={50} />
          <Button onClick={onClear} type="link">
            Clear
          </Button>
        </div>
      ) : null}
    </>
  );
};

export default Signature;
